import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import classNames from 'classnames';

import usePageTitle from '~/app/hooks/usePageTitle';
import useTranslation from '~/app/hooks/useTranslation';

import Loader from '~/app/common/Loader';

import { useAppHeader } from '~/app/modules/appHeader';
import ToggleSwitch from '~/app/common/ToggleSwitch/ToggleSwitch';

import { useStoreActions, useStoreState } from '~/store';

import Search from './Search';
import List from './List';

import classes from './style.module.scss';

import Icon from '~/app/common/Icon';
import { MaterialIcons as Icons } from '~/app/common/Icon/icons';
import { TASK_ROUTES } from '~/tasks/Router';
import { route } from '~/app/helpers/route';
import Button from '~/app/common/Button';
import { PROJECTS_ROUTES } from './Router';
import AccessControl from '~/accessControl';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import { TIME_MANAGEMENT_ROUTES } from '~/timeManagement/Router';
import useAccessControl from '~/app/hooks/useAccessControl';
export type ProjectsComponent = React.FC

const Projects: ProjectsComponent = () => {
  const [fetching, setFetching] = useState<boolean>(true);

  const { t } = useTranslation('project.listing');
  const { t: tb } = useTranslation('bottomNav');
  const hasTimeforingModule = useStoreState(state => state.tenant.hasTimeforingModule);
  usePageTitle(t('pageTitle'));
  const { checkPermission } = useAccessControl();
  const oppgaverPermission = checkPermission(PERMISSION_GROUPS.oppgaver);
  const timeManagementPermission = checkPermission(PERMISSION_GROUPS.timeManagement);

  const { setData } = useAppHeader();

  const lastUsedProjects = useStoreState(state => state.projects.lastUsed);
  const lastUsedProjectsFetchAction = useStoreActions(actions => actions.projects.fetchLastUsed);

  const favoritesProjects = useStoreState(state => state.projects.favorites);
  const favoritesProjectsFetchAction = useStoreActions(actions => actions.projects.fetchFavorites);

  const networkStatus = useStoreState(state => state.app.offline.status);
  const isSyncingOfflineData = useStoreState(state => state.app.offline.isSyncingOfflineData);

  useEffect(() => {
    setData({
      title: '',
      subTitle: '',
      backLink: undefined,
      showUser: true,
      machineId: '',
      projectId: '',
      parentFolderId: 0,
      showMachineMessages: false,
      isIssueDetailPage: false,
      isServiceDetailPage: false,
      notification: true,
      search: false
    });
  }, [setData]);

  useEffect(
    () => {
      Axios.all([
        lastUsedProjectsFetchAction(),
        favoritesProjectsFetchAction(),
      ]).finally(() => {
        setFetching(false);
      });
    },
    [favoritesProjectsFetchAction, lastUsedProjectsFetchAction, setFetching]
  );

  if (fetching) {
    return <Loader size="32" />;
  }
  return (
    <>
      <div>
        <div className={classNames(classes['title'], { [classes['offline']]: networkStatus })}>{t('title')}{!isSyncingOfflineData && !!window['cordova'] && <ToggleSwitch />}</div>

        {!networkStatus && <Search />}

        {!!lastUsedProjects.length && <List title={t('recentlyUsed')} list={lastUsedProjects} />}

        {!!favoritesProjects.length && <List title={t('favoriteProjects')} list={favoritesProjects} offline={!!networkStatus} />}

        {(!!networkStatus && !favoritesProjects.length && !lastUsedProjects.length) && (
          <div className={classes['offlineTextInfo']}>
            <b>{t('messageInfoTitle')} <br /><br />{t('messageInfoDescription')}
            </b>
          </div>
        )}
      </div>

      {!networkStatus && (oppgaverPermission || (hasTimeforingModule && timeManagementPermission)) &&
        <div className={classes['bottomNav']}>
          <Button className={classes['bottomButton']} to={route(PROJECTS_ROUTES.list)}>
            <Icon name={'home' as Icons} className={classes['bottomIcon']} />
            {tb('home')}
          </Button>
          {hasTimeforingModule && (
            <AccessControl requiredPermissions={PERMISSION_GROUPS.timeManagement}>
              <Button
                className={classes['bottomButton']}
                to={route(TIME_MANAGEMENT_ROUTES.list)}
              >
                <Icon name={'schedule' as Icons} className={classes['bottomIcon']} />
                {tb('timeManagement')}
              </Button>
            </AccessControl>
          )}
          {oppgaverPermission && <Button className={classes['bottomButton']} to={route(TASK_ROUTES.list)}>
            <Icon name={'assignment' as Icons} className={classes['bottomIcon']} />
            {tb('task')}
          </Button>}
        </div>
      }
    </>
  );
};

export default Projects
